import { useState } from "react";
import Button from "../../components/Button";
import { Link } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { handleBlur, handleShowPass } from "../../utility/action";
import {
  logInValidation,
  otpCodeValidation,
  otpEmailValidation,
} from "../../utility/Validation/validation";
import { yupResolver } from "@hookform/resolvers/yup";
import { notify } from "../../utility/Toastify/toastify";
import "../../styles/pages/Auth/auth.css";
import { setAuthData } from "../../redux/main/action/main";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { checkEmailException } from "../../utility/helper";
import axios from "axios";
import GoogleLoginButton from "./GoogleLoginButton";
import alert from "../../components/alerts/Alert";
import SixDigitInput from "../../components/mini-app/auth/SixDigitInput";
import { FiEdit } from "react-icons/fi";
import RecaptchaModal from "./login/RecaptchaModal";
import { MdEmail } from "react-icons/md";
import AuthLayout from "../../components/layout/AuthLayout";

function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [googleLoading, setGoogleLoading] = useState(false);
  const [code, setCode] = useState("");
  const [showRecaptchaModal, setShowRecaptchaModal] = useState(false);

  //google authentication integrated with AWS

  Amplify.configure({
    Auth: {
      identityPoolId: "us-east-1:dad77690-7bc3-4d24-bfc8-9a5bc43f1f6a",
      region: "us-east-1",
    },
  });

  const [formData, setFormData] = useState({});
  //btn loading
  const [loading, setLoading] = useState(false);
  const [loginType, setLoginType] = useState("otp");
  const [otpStep, setOtpStep] = useState(1);
  const [isNotTyping, setIsNotTyping] = useState(false);

  const validationSchema =
    loginType === "email"
      ? logInValidation
      : otpStep === 1
        ? otpEmailValidation
        : otpCodeValidation;

  // validation
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onBlur",
  });

  //form submit function
  const onsubmit = async (data) => {
    if (loginType === "otp") {
      if (loading) return;
      setLoading(true);
      if (otpStep === 1) {
        await axios
          .post(
            "https://weu658vyjj.execute-api.ap-southeast-2.amazonaws.com/dev/api",
            {
              operation_mode: "send_verification_code",
              email: checkEmailException(data?.email),
            },
          )
          .then((res) => {
            notify("Verification code sent", "success");
            setOtpStep(2);
          })
          .catch((err) => {
            alert(null, err?.response?.data?.message, "error", {
              cancel: "Ok",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }

      if (otpStep === 2) {
        setCode(data?.code);
        await axios
          .post(
            "https://weu658vyjj.execute-api.ap-southeast-2.amazonaws.com/dev/api",
            {
              operation_mode: "verify_verification_code",
              email: checkEmailException(data?.email),
              verification_code: data?.code,
            },
          )
          .then((res) => {
            const {
              accessToken: { jwtToken: token, payload: userData },
              refreshToken: { jwtToken: refreshToken },
            } = res?.data;

            dispatch(setAuthData(userData, token, refreshToken));

            // dispatch(setToken(jwtToken));
            // dispatch(setUserData(formatUserData(res?.data?.accessToken)));
            // localStorage.setItem(
            //   "aws-amplify-federatedInfo",
            //   JSON.stringify({ token: jwtToken }),
            // );
            // localStorage.setItem(
            //   "refreshToken",
            //   res?.data?.refreshToken?.token,
            // );
            axios.defaults.headers.common["Authorization"] = `${token}`;
            // navigate("/dashboard");
            navigate("/welcome");
          })
          .catch((err) => {
            alert(null, err?.response?.data?.message, "error", {
              cancel: "Ok",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }

    if (loginType === "email") {
      setFormData(data);
      setShowRecaptchaModal(true);
    }
  };

  // useEffect(() => {
  //   // dispatch(getRecaptcha());
  //
  //   dispatch(generateTextCaptcha());
  // }, [dispatch]);

  return (
    <>
      <AuthLayout>
        <div className="authContent">
          <div className="cc-auth__titleBlock">
            <h1 className="auth-title">Sign in to your account</h1>
            {/* <p className="cc-auth__subtitle">
              Choose OTP for a quick sign-in, or use your password.
            </p> */}
          </div>

          {/* {loginType === "otp" && otpStep === 1 && (
            <div className="cc-auth__social">
              <GoogleLoginButton setLoading={setGoogleLoading} />
            </div>
          )} */}
          <div className="cc-auth__social">
            <GoogleLoginButton setLoading={setGoogleLoading} />
          </div>

          <form
            className="login100-form validate-form cc-auth__form"
            onSubmit={handleSubmit(onsubmit)}
          >
            <p className="form-header">Or continue with your email</p>

            <div
              className={`cc-auth__switch ${
                loginType === "otp"
                  ? "cc-auth__switch--otp"
                  : "cc-auth__switch--email"
              } ${loading ? "cc-auth__switch--disabled" : ""}`}
              role="tablist"
              aria-label="Login method"
            >
              <button
                type="button"
                className={`cc-auth__switchBtn ${
                  loginType === "otp" ? "is-active" : ""
                }`}
                role="tab"
                aria-selected={loginType === "otp"}
                onClick={() => {
                  if (loading) return;
                  setLoginType("otp");
                }}
              >
                Email / OTP
              </button>
              <button
                type="button"
                className={`cc-auth__switchBtn ${
                  loginType === "email" ? "is-active" : ""
                }`}
                role="tab"
                aria-selected={loginType === "email"}
                onClick={() => {
                  if (loading) return;
                  setLoginType("email");
                }}
              >
                Email / Password
              </button>
            </div>

            {loginType === "otp" && (
              <>
                {otpStep === 1 && (
                  <>
                    <div className="cc-auth__field">
                      <div
                        className={`wrap-input100 validate-input ${
                          errors.email && "border-error"
                        }`}
                      >
                        <Controller
                          name="email"
                          control={control}
                          render={({ field }) => (
                            <input
                              className="input100 has-val"
                              type="text"
                              {...field}
                              onBlur={(e) => handleBlur(e)}
                              autoComplete="email"
                              placeholder="Email"
                            />
                          )}
                        />
                      </div>

                      {errors.email && (
                        <span className="error-text">
                          {errors.email.message}
                        </span>
                      )}
                    </div>

                    <Button
                      ButtonText={
                        googleLoading ? "Login with Google..." : "Send Code"
                      }
                      className={"signup cc-auth__primaryButton"}
                      loading={loading || googleLoading}
                    />

                    <div className="cc-auth__footer">
                      <span className="txt1">Don’t have an account?</span>
                      <Link className="txt2" to="/auth/signup">
                        Create Account
                      </Link>
                    </div>

                    <div className="cc-auth__footer cc-auth__footer--secondary">
                      <Link className="txt2" to="/auth/forgotPassword">
                        Forgot password
                      </Link>
                    </div>
                  </>
                )}

                {otpStep === 2 && (
                  <>
                    <p className="form-header">Enter the 6-digit code</p>

                    <div className="cc-auth__field">
                      <div
                        className={`cc-auth__otp ${
                          errors.code && isNotTyping
                            ? "cc-auth__otp--error"
                            : ""
                        }`}
                      >
                        <Controller
                          name="code"
                          control={control}
                          render={({ field }) => (
                            <SixDigitInput
                              value={code}
                              onChange={(value) => {
                                field.onChange(value);
                                setCode(value);
                              }}
                              onBlur={(e) => {
                                field.onBlur(e);
                                handleBlur(e);
                                setIsNotTyping(true);
                              }}
                              onFocus={() => setIsNotTyping(false)}
                            />
                          )}
                        />
                      </div>

                      {errors.code && isNotTyping && (
                        <span className="error-text">
                          {errors.code.message}
                        </span>
                      )}
                    </div>

                    <Button
                      ButtonText={"Login"}
                      className={"signup cc-auth__primaryButton"}
                      loading={loading}
                    />

                    <div className="spam-hint">
                      <MdEmail className="icon" />
                      Didn’t receive the code? Check your spam folder.
                    </div>

                    <div
                      className="edit-email-btn"
                      onClick={() => {
                        setOtpStep(1);
                        setCode("");
                      }}
                    >
                      <FiEdit /> Edit email
                    </div>
                  </>
                )}
              </>
            )}

            {loginType === "email" && (
              <>
                <div className="cc-auth__field">
                  <div
                    className={`wrap-input100 validate-input ${
                      errors.email && "border-error"
                    }`}
                  >
                    <input
                      className="input100 has-val"
                      type={"text"}
                      placeholder="Email"
                      {...register("email")}
                      onBlur={(e) => handleBlur(e)}
                      name="email"
                      autoComplete="email"
                    />
                  </div>
                  {errors.email && (
                    <span className="error-text">{errors.email.message}</span>
                  )}
                </div>

                <div className="cc-auth__field">
                  <div
                    className={`wrap-input100 validate-input ${
                      errors.pass && "border-error"
                    }`}
                  >
                    <span className="btn-show-pass">
                      <i
                        className="far fa-eye"
                        onClick={(e) => handleShowPass(e)}
                      ></i>
                    </span>
                    <input
                      className="input100 has-val"
                      type={"password"}
                      placeholder="Password"
                      {...register("pass")}
                      onBlur={(e) => handleBlur(e)}
                      name="pass"
                      autoComplete="current-password"
                    />
                  </div>
                  {errors.pass && (
                    <span className="error-text">{errors.pass.message}</span>
                  )}
                </div>

                <Button
                  ButtonText={"LogIn"}
                  className={"signup cc-auth__primaryButton"}
                  loading={loading || googleLoading}
                />

                <div className="cc-auth__footer">
                  <span className="txt1">Don’t have an account?</span>
                  <Link className="txt2" to="/auth/signup">
                    Create Account
                  </Link>
                </div>

                <div className="cc-auth__footer cc-auth__footer--secondary">
                  <Link className="txt2" to="/auth/forgotPassword">
                    Forgot password
                  </Link>
                </div>
              </>
            )}
          </form>
        </div>
      </AuthLayout>
      <RecaptchaModal
        open={showRecaptchaModal}
        onClose={() => setShowRecaptchaModal(false)}
        data={formData}
        useCase="login"
      />
    </>
  );
}

export default LoginPage;
